<nb-card>
	<nb-card-body class="tabset">
		<nb-route-tabset [tabs]="tabs"></nb-route-tabset>
	</nb-card-body>
</nb-card>
